import * as React from 'react'
import { IJsonResponse } from 'core/JsonApiSerializer'
import HostIndex from './indexPage/host'
import GuestIndex from './indexPage/guest'
import { BREAKPOINT_TABLET_SMALL } from 'static/constants'

interface IProps {
  reservations: {
    reservations: IJsonResponse
  }
  currentUser: any
  currentUserIsHost: any
  records: {
    records: IJsonResponse
  }
  currentUserIsAgent: any
  user: any
  host_cancel_reasons: IJsonResponse
  csv_path: string
}

const ReservationsIndex: React.FC<IProps> = props => {
  const isMobile = matchMedia(`(max-width: ${BREAKPOINT_TABLET_SMALL}px)`).matches

  return props.currentUserIsHost ? (
    <HostIndex {...props} isMobile={isMobile} />
  ) : (
    <GuestIndex {...props} isMobile={isMobile} />
  )
}

export default ReservationsIndex
